module.exports = __webpack_public_path__ + "static/img/star-year-no1.ec195593.png";